import React, {Component, PropTypes} from "react";
import {connect} from 'react-redux'
import {changeCustomerEmail} from '../actions'

class CustomerEmailField extends Component {

    constructor(props) {
        super(props);
        const {open, formAssigneeEmail, email, formId, username} = props;

        this.state = {
            open: email === "" ? true : false,
            hidenew: false,
            formAssigneeEmail: formAssigneeEmail,
            formId: formId,
            email: email,
            origemail: email,
            username: username
        };
    }

    getInitialState() {
        return {
            "formAssigneeEmail": this.props.formAssigneeEmail
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({...nextProps});
    }

    onStateChange = (e) => {
        e.preventDefault();
        const { hidenew, open, email } = this.state;
        this.setState({
            "open": !open
        });
        if (email === "") {
            this.setState({
               "hidenew": true
            });
        }
    }

    onEmailChange(newvalue) {
        this.setState({
            "email": newvalue
        });
    }

    onSaveButtonClick() {
        const { formId, formAssigneeEmail, email, origemail } = this.state;
        this.setState({
            "open": !this.state.open,
            "hidenew": true
        });

        //TODO: update formAssigneeEmail with new email value
        var emaillist = formAssigneeEmail.split(";");
        if (origemail !== "") {
            //emaillist[emaillist.find(e => { return e === email})] = email;

            //console.log("emaillist (before foreach): " + emaillist.join(';'));
            emaillist.forEach((item, index) => {
                if (item === origemail) {
                    console.log("found " + item);
                    emaillist[index] = email;
                }
            })
            //console.log("emaillist (after foreach): " + emaillist.join(';'));
        } else {
            emaillist = emaillist.concat(email);
        }
        // remove empty strings if any exist

        emaillist = emaillist.filter(item => { return item != ""});
        // console.log("email: " + email);
        // console.log("origemail: " + origemail);
        //
        // console.log("emaillist: " + emaillist.join(';'));
        this.props.dispatch(changeCustomerEmail(formId, {"formAssigneeEmail": emaillist.join(';')}))
    }

    onRemoveButtonClick() {
        const { formId, formAssigneeEmail,  origemail, username } = this.state;
        this.setState({
            "open": !this.state.open,
            "hidenew": true
        });
        //TODO: update formAssigneeEmail with new email value
        var emaillist = formAssigneeEmail.split(";");
        if (origemail != "" && origemail != username) {
            emaillist = emaillist.filter(i => { return i != origemail});
            this.props.dispatch(changeCustomerEmail(formId, {"formAssigneeEmail": emaillist.join(';')}))
        }

    }

    render() {
        const {open, hidenew, email, username} = this.state;
        //debugger;
        if (hidenew) {
            return (<div></div>)
        }
        if (!open && email != "") {

            return (
                <div >
                    {email}
                    {email !== username ? <button type="button" onClick={this.onStateChange.bind(this)} className="btn btn-link" aria-label="Left Align" title="Edit customer email">
                        <span className="glyphicon glyphicon-pencil" aria-hidden="true"></span>
                    </button> : ""}
                </div>
            )
        }
        //debugger;
        return (
            <div >
                <input type="text" placeholder="Customer email" size="35"
                       value={email} onChange={(event) => this.onEmailChange(event.target.value)}></input>


                <button type="button" onClick={this.onSaveButtonClick.bind(this)} className="btn btn-link" aria-label="Left Align" title="Save changes">
                    <span className="glyphicon glyphicon-ok" style={{fontSize: "1.6em"}} aria-hidden="true"></span>
                </button>
                &nbsp;&nbsp;&nbsp;
                <button className="text-muted btn btn-link" onClick={this.onStateChange.bind(this)}>Cancel</button>
                &nbsp;&nbsp;&nbsp;
                <button type="button" onClick={this.onRemoveButtonClick.bind(this)} className="btn btn-link" aria-label="Left Align" title="Remove email address">
                    <span className="glyphicon glyphicon-remove" style={{color: "red", fontSize: "1.6em"}} aria-hidden="true"></span>
                </button>
            </div>
        );
    }
}

CustomerEmailField.defaultProps = {
    open: false
};


function mapStateToProps(state) {

    return {

    }
}

export default connect(mapStateToProps)(CustomerEmailField)




// WEBPACK FOOTER //
// ./src/containers/CustomerEmailField.js